module.exports = __webpack_public_path__ + "static/media/check-mark.cbfbdf02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-mark.svg
// module id = 549
// module chunks = 0